import { IconArrowLeft, IconChartPie } from '@tabler/icons-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableRowHeader,
} from '@/components/ui/table';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

// Mock data for the Current State analysis
const precentricData = [
  {
    paymentType: 'Foreign Exchange',
    spend: 263001.0,
    transactionCount: 40,
    supplierCount: 8,
    percentOfSuppliers: 1,
    percentOfSpend: 0,
    percentOfRevGeneratingSpend: 0,
    percentOfRevGeneratingTransactions: 0,
  },
  {
    paymentType: 'Wire Transfer',
    spend: 38869434.0,
    transactionCount: 5130,
    supplierCount: 179,
    percentOfSuppliers: 17,
    percentOfSpend: 37,
    percentOfRevGeneratingSpend: 37,
    percentOfRevGeneratingTransactions: 20,
  },
  {
    paymentType: 'Check',
    spend: 65343307.0,
    transactionCount: 19376,
    supplierCount: 819,
    percentOfSuppliers: 80,
    percentOfSpend: 62,
    percentOfRevGeneratingSpend: 0,
    percentOfRevGeneratingTransactions: 0,
    icon: '🏦',
  },
  {
    paymentType: 'Virtual Card',
    spend: 1243013.0,
    transactionCount: 1134,
    supplierCount: 22,
    percentOfSuppliers: 2,
    percentOfSpend: 1,
    percentOfRevGeneratingSpend: 1,
    percentOfRevGeneratingTransactions: 4,
    icon: '💳',
  },
];

const suppliersSpendData = [
  {
    name: 'ONYX CENTERSOURCE',
    vendorId: 'BT_0687',
    taxId: '',
    type: 'Strategic',
    transactionCount: 176,
    totalSpend: 2575349.0,
  },
  {
    name: 'TAMBOURNE',
    vendorId: 'BT_0903',
    taxId: '',
    type: 'Strategic',
    transactionCount: 138,
    totalSpend: 2518487.0,
  },
  {
    name: 'US FOOD',
    vendorId: 'BT_0984',
    taxId: '',
    type: 'Strategic',
    transactionCount: 268,
    totalSpend: 2375616.0,
  },
  {
    name: 'FUJITEC AMERICA',
    vendorId: 'BT_0374',
    taxId: '',
    type: 'Strategic',
    transactionCount: 42,
    totalSpend: 2332610.0,
  },
  {
    name: 'NEVADA DEPARTMENT OF TAXATION',
    vendorId: 'BT_0641',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 60,
    totalSpend: 2148947.0,
  },
  {
    name: 'HEALTH PLAN OF NEVADA',
    vendorId: 'BT_0422',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 78,
    totalSpend: 2002935.0,
  },
  {
    name: 'US FOOD',
    vendorId: 'BT_0985',
    taxId: '',
    type: 'Strategic',
    transactionCount: 246,
    totalSpend: 1843583.0,
  },
  {
    name: 'CONSOLIDATED EDISON',
    vendorId: 'BT_0235',
    taxId: '',
    type: 'Strategic',
    transactionCount: 108,
    totalSpend: 1782594.0,
  },
  {
    name: 'DIRECT ENERGY BUSINESS',
    vendorId: 'BT_0282',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 126,
    totalSpend: 1739419.0,
  },
  {
    name: 'BOOKING.COM',
    vendorId: 'BT_0133',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 32,
    totalSpend: 1710720.0,
  },
  {
    name: 'NEVADA GAMING COMMISSION',
    vendorId: 'BT_0645',
    taxId: '',
    type: 'Exempt',
    transactionCount: 30,
    totalSpend: 1693634.0,
  },
  {
    name: 'EXPEDIA',
    vendorId: 'BT_0333',
    taxId: '',
    type: 'Strategic',
    transactionCount: 74,
    totalSpend: 1587291.0,
  },
  {
    name: 'UNIVERSAL LAUNDRIES & LINEN SUPPLY',
    vendorId: 'BT_0979',
    taxId: '',
    type: 'Strategic',
    transactionCount: 50,
    totalSpend: 1485520.0,
  },
  {
    name: 'TAYLOR INTERNATIONAL',
    vendorId: 'BT_0906',
    taxId: '',
    type: 'Strategic',
    transactionCount: 8,
    totalSpend: 1485169.0,
  },
  {
    name: 'TRINITY HUDSON HOLDINGS',
    vendorId: 'BT_0954',
    taxId: '',
    type: 'Strategic',
    transactionCount: 26,
    totalSpend: 1477777.0,
  },
];

const suppliersTransactionData = [
  {
    name: 'AMAZON CAPITAL SERVICES',
    vendorId: 'BT_0044',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 638,
    totalSpend: 727725.0,
  },
  {
    name: 'DOMINICK HOTEL',
    vendorId: 'BT_0920',
    taxId: '',
    type: 'General',
    transactionCount: 334,
    totalSpend: 108692.0,
  },
  {
    name: 'NYHTC & HANYC',
    vendorId: 'BT_0672',
    taxId: '',
    type: 'Strategic',
    transactionCount: 334,
    totalSpend: 1446478.0,
  },
  {
    name: 'US FOOD',
    vendorId: 'BT_0984',
    taxId: '',
    type: 'Strategic',
    transactionCount: 268,
    totalSpend: 2375616.0,
  },
  {
    name: 'US FOOD',
    vendorId: 'BT_0985',
    taxId: '',
    type: 'Strategic',
    transactionCount: 246,
    totalSpend: 1843583.0,
  },
  {
    name: 'LA SPECIALTY',
    vendorId: 'BT_0527',
    taxId: '',
    type: 'Strategic',
    transactionCount: 226,
    totalSpend: 1046671.0,
  },
  {
    name: 'CINTAS',
    vendorId: 'BT_0197',
    taxId: '',
    type: 'Network Name Match Virtual Card',
    transactionCount: 210,
    totalSpend: 620661.0,
  },
  {
    name: 'ADP',
    vendorId: 'BT_0023',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 208,
    totalSpend: 268066.0,
  },
  {
    name: 'BALDOR SPECIALTY FOODS',
    vendorId: 'BT_0091',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 202,
    totalSpend: 696838.0,
  },
  {
    name: 'FREEDOMPAY',
    vendorId: 'BT_0367',
    taxId: '',
    type: 'General',
    transactionCount: 194,
    totalSpend: 54222.0,
  },
  {
    name: 'GREAT BUNS BAKERY',
    vendorId: 'BT_0401',
    taxId: '',
    type: 'General',
    transactionCount: 192,
    totalSpend: 116521.0,
  },
  {
    name: 'PAT LAFRIEDA',
    vendorId: 'BT_0716',
    taxId: '',
    type: 'General',
    transactionCount: 190,
    totalSpend: 322407.0,
  },
  {
    name: 'OFFICE DEPOT',
    vendorId: 'BT_0679',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 182,
    totalSpend: 59658.0,
  },
  {
    name: 'ONYX CENTERSOURCE',
    vendorId: 'BT_0687',
    taxId: '',
    type: 'Strategic',
    transactionCount: 176,
    totalSpend: 2575349.0,
  },
  {
    name: 'PRUDENTIAL OVERALL SUPPLY',
    vendorId: 'BT_0758',
    taxId: '',
    type: 'Network Name Match',
    transactionCount: 176,
    totalSpend: 145897.0,
  },
];

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
};

const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('en-US').format(num);
};

export const CurrentState: React.FC = () => {
  const [activeSupplierTab, setActiveSupplierTab] = useState('spend');
  const [hoveredSegment, setHoveredSegment] = useState<string | null>(null);

  const totalSpend = precentricData.reduce((sum, item) => sum + item.spend, 0);
  const totalTransactions = precentricData.reduce((sum, item) => sum + item.transactionCount, 0);
  const totalSuppliers = precentricData.reduce((sum, item) => sum + item.supplierCount, 0);

  return (
    <div className="flex flex-col gap-6 py-4 md:py-6">
      {/* Header */}
      <div className="px-4 lg:px-6">
        <div className="flex items-center gap-4 mb-4">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/prospect-module">
              <IconArrowLeft className="h-4 w-4 mr-2" />
              Back to Account Setup
            </Link>
          </Button>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <IconChartPie className="h-6 w-6" />
            <h1 className="text-2xl font-bold tracking-tight">Current State Analysis</h1>
          </div>
        </div>
        <p className="text-muted-foreground mt-2">
          Comprehensive analysis of current payment landscape and supplier data
        </p>
      </div>

      {/* Summary Charts Row - Top Visual Overview */}
      <div className="px-4 lg:px-6">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {/* Effective Rebate */}
          <Card>
            <CardHeader>
              <CardTitle className="text-lg text-center">Effective Rebate</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-center">
                <div className="text-8xl font-bold text-blue-600 mb-2">0%</div>
              </div>
            </CardContent>
          </Card>

          {/* Birchstreet Demonstration Effort */}
          <Card>
            <CardHeader>
              <CardTitle className="text-sm text-center">
                Birchstreet Demonstration 10-16-24 Effort
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-center space-y-4">
                <div className="relative mx-auto w-32 h-32">
                  <svg
                    className="w-full h-full transform -rotate-90"
                    viewBox="0 0 120 120"
                    aria-label="Progress chart showing 100% completion"
                  >
                    <title>Progress chart showing 100% completion</title>
                    <circle cx="60" cy="60" r="54" fill="none" stroke="#e5e7eb" strokeWidth="12" />
                    <circle
                      cx="60"
                      cy="60"
                      r="54"
                      fill="none"
                      stroke="#3b4f8f"
                      strokeWidth="12"
                      strokeDasharray="339.292"
                      strokeDashoffset="0"
                      strokeLinecap="round"
                    />
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-2xl font-bold text-foreground">100%</span>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-2 text-sm">
                  <div className="w-3 h-3 rounded-full bg-[#3b4f8f]" />
                  <span>Birchstreet Demonstration 10-16-24</span>
                  <span className="font-semibold">100.0%</span>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Payment Volume Distribution */}
          <Card>
            <CardHeader>
              <CardTitle className="text-lg text-center">Payment Volume Distribution</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-center space-y-4">
                <div className="relative mx-auto w-32 h-32">
                  <svg
                    className="w-full h-full"
                    viewBox="0 0 120 120"
                    aria-label="Payment volume distribution pie chart"
                  >
                    <title>Payment volume distribution pie chart</title>
                    {/* Background circle */}
                    <circle cx="60" cy="60" r="50" fill="none" stroke="#e5e7eb" strokeWidth="20" />
                    {/* Check - 62% (starts at top) */}
                    <circle
                      cx="60"
                      cy="60"
                      r="50"
                      fill="none"
                      stroke="#14b8a6"
                      strokeWidth="20"
                      strokeDasharray="194.78 314.16"
                      strokeDashoffset="0"
                      transform="rotate(-90 60 60)"
                      style={{ cursor: 'pointer' }}
                      role="button"
                      tabIndex={0}
                      onMouseEnter={() => setHoveredSegment('check')}
                      onMouseLeave={() => setHoveredSegment(null)}
                    />
                    {/* Electronic (Wire Transfer) - 37% */}
                    <circle
                      cx="60"
                      cy="60"
                      r="50"
                      fill="none"
                      stroke="#1e3a8a"
                      strokeWidth="20"
                      strokeDasharray="116.27 314.16"
                      strokeDashoffset="-194.78"
                      transform="rotate(-90 60 60)"
                      style={{ cursor: 'pointer' }}
                      role="button"
                      tabIndex={0}
                      onMouseEnter={() => setHoveredSegment('electronic')}
                      onMouseLeave={() => setHoveredSegment(null)}
                    />
                    {/* Virtual Card - 1% */}
                    <circle
                      cx="60"
                      cy="60"
                      r="50"
                      fill="none"
                      stroke="#84cc16"
                      strokeWidth="20"
                      strokeDasharray="3.14 314.16"
                      strokeDashoffset="-311.05"
                      transform="rotate(-90 60 60)"
                      style={{ cursor: 'pointer' }}
                      role="button"
                      tabIndex={0}
                      onMouseEnter={() => setHoveredSegment('virtualcard')}
                      onMouseLeave={() => setHoveredSegment(null)}
                    />
                  </svg>

                  {/* Tooltips */}
                  {hoveredSegment === 'check' && (
                    <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white px-3 py-2 rounded-sm text-sm font-medium z-10 whitespace-nowrap">
                      <div className="text-center">
                        <div className="font-semibold">Check Payments</div>
                        <div>62% • {formatCurrency(65343307.0)}</div>
                        <div>{formatNumber(19376)} transactions</div>
                      </div>
                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900" />
                    </div>
                  )}

                  {hoveredSegment === 'electronic' && (
                    <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white px-3 py-2 rounded-sm text-sm font-medium z-10 whitespace-nowrap">
                      <div className="text-center">
                        <div className="font-semibold">Electronic Payments</div>
                        <div>37% • {formatCurrency(39132435.0)}</div>
                        <div>{formatNumber(5170)} transactions</div>
                      </div>
                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-gray-900" />
                    </div>
                  )}

                  {hoveredSegment === 'virtualcard' && (
                    <div className="absolute -right-16 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-sm text-sm font-medium z-10 whitespace-nowrap">
                      <div className="text-center">
                        <div className="font-semibold">Virtual Card</div>
                        <div>1% • {formatCurrency(1243013.0)}</div>
                        <div>{formatNumber(1134)} transactions</div>
                      </div>
                      <div className="absolute right-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-900" />
                    </div>
                  )}
                  {/* Center content */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center">
                      <div className="text-sm font-semibold">Total</div>
                      <div className="text-lg font-bold">{formatNumber(totalTransactions)}</div>
                    </div>
                  </div>
                </div>
                <div className="space-y-1 text-xs">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-2 bg-teal-500 rounded-full" />
                      <span>Check</span>
                    </div>
                    <span className="font-semibold">62%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-2 bg-blue-900 rounded-full" />
                      <span>Electronic</span>
                    </div>
                    <span className="font-semibold">37%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-2 bg-lime-500 rounded-full" />
                      <span>Virtual Card</span>
                    </div>
                    <span className="font-semibold">1%</span>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Pre-Centric Optimization Table - Full Width */}
      <div className="px-4 lg:px-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Pre-Centric Optimization</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <Table caption="Pre-Centric Optimization by payment type">
                <TableHeader>
                  <TableRow>
                    <TableHead>Payment Type</TableHead>
                    <TableHead className="text-right">Spend</TableHead>
                    <TableHead className="text-right">Transaction Count</TableHead>
                    <TableHead className="text-right">Supplier Count</TableHead>
                    <TableHead className="text-right">% of Suppliers</TableHead>
                    <TableHead className="text-right">% of Spend</TableHead>
                    <TableHead className="text-right">% of Rev. Generating Spend</TableHead>
                    <TableHead className="text-right">% of Rev. Generating Transactions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {precentricData.map((row) => (
                    <TableRow key={row.paymentType}>
                      <TableRowHeader className="font-medium">
                        <div className="flex items-center gap-2">
                          {/* Decorative emoji: it would otherwise be read out
                              as part of the row's name. */}
                          {row.icon && <span aria-hidden="true">{row.icon}</span>}
                          {row.paymentType}
                        </div>
                      </TableRowHeader>
                      <TableCell className="text-right font-mono">
                        {formatCurrency(row.spend)}
                      </TableCell>
                      <TableCell className="text-right">
                        {formatNumber(row.transactionCount)}
                      </TableCell>
                      <TableCell className="text-right">
                        {formatNumber(row.supplierCount)}
                      </TableCell>
                      <TableCell className="text-right">{row.percentOfSuppliers}%</TableCell>
                      <TableCell className="text-right">{row.percentOfSpend}%</TableCell>
                      <TableCell className="text-right">
                        {row.percentOfRevGeneratingSpend}%
                      </TableCell>
                      <TableCell className="text-right">
                        {row.percentOfRevGeneratingTransactions}%
                      </TableCell>
                    </TableRow>
                  ))}
                  {/* Total Row */}
                  <TableRow className="border-t-2 font-semibold bg-muted/50">
                    <TableCell>Total</TableCell>
                    <TableCell className="text-right font-mono">
                      {formatCurrency(totalSpend)}
                    </TableCell>
                    <TableCell className="text-right">{formatNumber(totalTransactions)}</TableCell>
                    <TableCell className="text-right">{formatNumber(totalSuppliers)}</TableCell>
                    <TableCell className="text-right">100%</TableCell>
                    <TableCell className="text-right">100%</TableCell>
                    <TableCell className="text-right">38%</TableCell>
                    <TableCell className="text-right">25%</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Payment Mix Comparison */}
      <div className="px-4 lg:px-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Payment Mix Comparison</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <span className="font-medium">Current</span>
              </div>
              <div className="relative">
                <div className="flex h-12 overflow-hidden">
                  <div
                    className="bg-teal-400 flex items-center justify-center text-white font-medium text-sm"
                    style={{ width: '62%' }}
                  >
                    Check: {formatCurrency(65343307.0)}
                  </div>
                  <div
                    className="bg-blue-900 flex items-center justify-center text-white font-medium text-sm"
                    style={{ width: '37%' }}
                  >
                    Electronic: {formatCurrency(39132435.0)}
                  </div>
                  <div
                    className="bg-green-400 flex items-center justify-center text-white font-medium text-sm"
                    style={{ width: '1%' }}
                  >
                    Virtual Card: {formatCurrency(1243013.0)}
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center gap-6 text-sm">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-teal-400 rounded" />
                  <span>Check</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-blue-900 rounded" />
                  <span>Electronic</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-green-400 rounded" />
                  <span>Virtual Card</span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Supplier Tables */}
      <div className="px-4 lg:px-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Top 15 Suppliers Analysis</CardTitle>
          </CardHeader>
          <CardContent>
            <Tabs value={activeSupplierTab} onValueChange={setActiveSupplierTab}>
              <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="spend">Top 15 Suppliers By Spend</TabsTrigger>
                <TabsTrigger value="transaction">Top 15 Suppliers By Transaction</TabsTrigger>
              </TabsList>

              <TabsContent value="spend" className="mt-6">
                <div className="overflow-x-auto">
                  {/* Named from the tab, not the card title: both tabs share
                      "Top 15 Suppliers Analysis", which would name two tables
                      identically. */}
                  <Table caption="Top 15 suppliers by spend">
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Vendor ID</TableHead>
                        <TableHead>Tax ID</TableHead>
                        <TableHead>Type</TableHead>
                        <TableHead className="text-right">Transaction Count</TableHead>
                        <TableHead className="text-right">Total Spend</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {suppliersSpendData.map((supplier) => (
                        <TableRow key={supplier.vendorId}>
                          <TableRowHeader className="font-medium">{supplier.name}</TableRowHeader>
                          <TableCell>{supplier.vendorId}</TableCell>
                          <TableCell>{supplier.taxId}</TableCell>
                          <TableCell>
                            <span
                              className={`px-2 py-1 rounded-sm text-xs ${
                                supplier.type === 'Strategic'
                                  ? 'bg-blue-100 text-blue-800'
                                  : supplier.type === 'Network Name Match'
                                    ? 'bg-green-100 text-green-800'
                                    : supplier.type === 'Exempt'
                                      ? 'bg-muted text-foreground'
                                      : 'bg-orange-100 text-orange-800'
                              }`}
                            >
                              {supplier.type}
                            </span>
                          </TableCell>
                          <TableCell className="text-right">
                            {formatNumber(supplier.transactionCount)}
                          </TableCell>
                          <TableCell className="text-right font-mono">
                            {formatCurrency(supplier.totalSpend)}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow className="border-t-2 font-semibold bg-muted/50">
                        <TableCell>Total</TableCell>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell className="text-right">
                          {formatNumber(
                            suppliersSpendData.reduce((sum, s) => sum + s.transactionCount, 0)
                          )}
                        </TableCell>
                        <TableCell className="text-right font-mono">
                          {formatCurrency(
                            suppliersSpendData.reduce((sum, s) => sum + s.totalSpend, 0)
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>

              <TabsContent value="transaction" className="mt-6">
                <div className="overflow-x-auto">
                  <Table caption="Top 15 suppliers by transaction count">
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Vendor ID</TableHead>
                        <TableHead>Tax ID</TableHead>
                        <TableHead>Type</TableHead>
                        <TableHead className="text-right">Transaction Count</TableHead>
                        <TableHead className="text-right">Total Spend</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {suppliersTransactionData.map((supplier) => (
                        <TableRow key={`${supplier.vendorId}-transaction`}>
                          <TableRowHeader className="font-medium">{supplier.name}</TableRowHeader>
                          <TableCell>{supplier.vendorId}</TableCell>
                          <TableCell>{supplier.taxId}</TableCell>
                          <TableCell>
                            <span
                              className={`px-2 py-1 rounded-sm text-xs ${
                                supplier.type === 'Strategic'
                                  ? 'bg-blue-100 text-blue-800'
                                  : supplier.type === 'Network Name Match'
                                    ? 'bg-green-100 text-green-800'
                                    : supplier.type.includes('Virtual Card')
                                      ? 'bg-purple-100 text-purple-800'
                                      : 'bg-orange-100 text-orange-800'
                              }`}
                            >
                              {supplier.type}
                            </span>
                          </TableCell>
                          <TableCell className="text-right">
                            {formatNumber(supplier.transactionCount)}
                          </TableCell>
                          <TableCell className="text-right font-mono">
                            {formatCurrency(supplier.totalSpend)}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow className="border-t-2 font-semibold bg-muted/50">
                        <TableCell>Total</TableCell>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell className="text-right">
                          {formatNumber(
                            suppliersTransactionData.reduce((sum, s) => sum + s.transactionCount, 0)
                          )}
                        </TableCell>
                        <TableCell className="text-right font-mono">
                          {formatCurrency(
                            suppliersTransactionData.reduce((sum, s) => sum + s.totalSpend, 0)
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
